import React from "react";
import FeedBack from "./FeadBack/FeedBack";

import Principal from "./Principal/Principal";

const Home = () => {
  return (
    <div>
      <Principal></Principal>
      <FeedBack />
    </div>
  );
};

export default Home;
